import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import {
  MoonIcon, SunIcon,
  ArrowsExpandIcon, ArrowLeftIcon,
} from '@heroicons/react/outline';
import LogoLight from '../../assets/images/logo-light.png';
import LogoDark from '../../assets/images/logo-dark.png';

const Navbar = ({ courseTitle, isFullscreen, toggleFullscreen }) => {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  return (
    <header className="fixed top-0 left-0 right-0 bg-white dark:bg-gray-800 border-b border-gray-300 dark:border-gray-700 z-50">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        {/* Right - Logo */}
        <div className="flex-shrink-0 flex items-center">
          <Link to="/">
            <img
              className="h-12 w-auto"
              src={theme === 'dark' ? LogoDark : LogoLight}
              alt="دوز التعليمية"
            />
          </Link>
        </div>

        {/* Center - Course Title */}
        <h1 className="text-lg font-bold text-gray-900 dark:text-white text-center flex-1 hidden md:block">
          {courseTitle}
        </h1>

        {/* Left - Controls */}
        <div className="flex items-center gap-4">
          {/* Theme Toggle */}
          <button
            onClick={toggleTheme}
            className="p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
          >
            {theme === 'dark' ? (
              <SunIcon className="h-6 w-6 text-yellow-400 transition-colors duration-200" />
            ) : (
              <MoonIcon className="h-6 w-6 text-indigo-500 dark:text-indigo-400 transition-colors duration-200" />
            )}
          </button>

          {/* Fullscreen Toggle */}
          <button
            onClick={toggleFullscreen}
            className="hidden md:block p-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
          >
            <ArrowsExpandIcon className="h-6 w-6 text-green-500" />
          </button>

          {/* Back Button */}
          <button 
            onClick={() => {
              // استخراج رقم الكورس من الرابط الحالي
              const pathParts = window.location.pathname.split('/');
              const courseId = pathParts[2]; // الجزء الثالث من المسار هو رقم الكورس
              
              // الذهاب مباشرة لصفحة تفاصيل الكورس باستخدام window.location.href
              window.location.href = `/courses/${courseId}`;
            }}
            className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
          >
            <ArrowLeftIcon className="h-6 w-6" />
            <span className="hidden sm:inline">رجوع</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;